import { isAdsUser } from '@/services/userRoles'

/**
 * Secciones Luz y Gas del menú de suministros.
 *
 * Todos los perfiles abren aquí el historial de solicitudes acotado por
 * suministro (`/request?supply=light|gas`), no los puntos de suministro: la
 * mayoría de clientes verticales no tiene contratos cargados y veía las tablas
 * vacías, y ADS ve lo mismo que el cliente con la columna de la cuenta
 * (ADSREC-0006).
 *
 * Los perfiles ADS conservan las rutas `/luz` y `/gas` con los CUPS de todas
 * las cuentas (accesos del Inicio y de Administradores); a los clientes se les
 * redirige al historial.
 */
export const showsSupplyRequests = () => !isAdsUser()

export const supplySectionPath = (type) => ({ path: '/request', query: { supply: type } })

/**
 * Clave de traducción del botón. El cliente lee "Historial de tus solicitudes
 * de luz" y ADS, que ve las de todas las cuentas, "Historial de solicitudes de
 * luz".
 */
export const supplySectionTitleKey = (type) => {
  if (isAdsUser()) return type === 'gas' ? 'menu.adsGasRequests' : 'menu.adsElectricityRequests'
  return type === 'gas' ? 'menu.gasRequests' : 'menu.electricityRequests'
}
